import { ReactElement, useMemo, memo } from 'react';
import { ColumnDescription } from 'react-bootstrap-table-next';

import { ApiTransactionItem } from '~services/apiTransaction/types';
import {
  OrderClientInfo,
  SkillsListInfo,
  CapabilitiesInfo,
  DataTable,
} from '~components/index';

import { TABLE_KEY_FIELDS } from '../../../../../../utils/constants';

import { useAssistantGenerateRoutesDialogByTemplateContext } from '../../../../../Context';
import { getItemsBySelectedTemplate } from '../../../../../utils';

import { AssistantGenerateRoutesDialogByTemplateContentFormTableContainer } from '../../styles';

const AssistantGenerateRoutesDialogByTemplateContentFormTemplateSelectedDataItemsTable =
  (): ReactElement => {
    const {
      data: {
        selectedTemplate: { value: selectedTemplate },
      },
    } = useAssistantGenerateRoutesDialogByTemplateContext();

    const data = useMemo(
      () => getItemsBySelectedTemplate(selectedTemplate),
      [selectedTemplate],
    );

    const columns = useMemo<ColumnDescription<ApiTransactionItem>[]>(
      () => [
        {
          dataField: 'title',
          text: 'Nombre de contacto',
          formatter: (_cell, row) => (
            <OrderClientInfo
              name={row.title}
              itemTypeId={row.itemTypeId}
              trackingCode={row.trackingCode}
            />
          ),
        },
        {
          dataField: 'tags',
          text: 'Grupo',
          classes: 'truncated-two-lines',
          formatter: (cell) => <span>{cell}</span>,
          headerStyle: { width: 120 },
        },
        {
          dataField: 'skillsNeeded',
          text: 'Cargas especiales',
          classes: 'truncated-two-lines',
          formatter: (cell) => <SkillsListInfo skills={cell} />,
          headerStyle: { width: 250 },
          align: 'center',
        },
        {
          dataField: 'unit1',
          text: 'Capacidades',
          formatter: (_cell, row) => (
            <CapabilitiesInfo
              capacity1={row.unit1 * row.amount}
              capacity2={row.unit2 * row.amount}
              numberOfPackages={row.numberOfPackages}
              maximumVisits={null}
              fontSize={12}
              fontWeight="bold"
            />
          ),
          headerStyle: { width: 250 },
        },
      ],
      [],
    );

    return (
      <AssistantGenerateRoutesDialogByTemplateContentFormTableContainer>
        <DataTable
          loading={false}
          data={data}
          columns={columns}
          keyField={TABLE_KEY_FIELDS.ORDER}
          condensed
        />
      </AssistantGenerateRoutesDialogByTemplateContentFormTableContainer>
    );
  };

export default memo(
  AssistantGenerateRoutesDialogByTemplateContentFormTemplateSelectedDataItemsTable,
);
